import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentVerifyComponent } from './document-verify/document-verify.component';
import { PQRformComponent } from './pqrform/pqrform.component';
import { PqrSearchComponent } from './pqr-search/pqr-search.component';
import { HomeComponent } from './home/home.component';
import { RadicarComponent } from './radicar/radicar.component';

@NgModule({
  declarations: [
    AppComponent,
    DocumentVerifyComponent,
    PQRformComponent,
    PqrSearchComponent,
    HomeComponent,
    RadicarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    RecaptchaModule,
    FormsModule,
    RecaptchaFormsModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
